<template>
  <div style="padding-bottom: 5px;">
    <base-button
      v-if="Id > 0"
      class="btn_extra_small btn_info move-right"
      style="left : 10px;"
      @click.native="viewAcsa"
      >View ACSA</base-button
    >
    <span v-else class="label_warning move-right-label">NO ACSA FOUND</span>
    <!-- Classic Modal -->
    <modal style="z-index: 10;" :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">ACSA</h4>
      <hr />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div>Created: <strong>{{countryAcsaAgreement.createDate}}</strong></div>
          </div>
          <div class="col-md-6">
            <div>Modified: <strong>{{countryAcsaAgreement.updateDate}}</strong></div>
          </div>
        </div>

        <label style="padding-top: 10px;">Name</label>
        <base-input v-model="countryAcsaAgreement.name"  name="aaName" :disabled="true"></base-input>

        <label style="padding-top: 10px;">Remark</label>
        <base-input
          v-model="countryAcsaAgreement.remark"
          name="aaRemark"
          :disabled="true"
        ></base-input>

        <div class="row">
          <el-table :data="countryAcsaAgreement.files" role="table"
        aria-label="Agreement Information Table">
            <el-table-column :min-width="135" align="left" label="Actions">
              <div slot-scope="props">
                <button
                :disabled="downloading"
                  class="btn_extra_small btn_info text_small"
                  @click="
                    generateReport(
                      countryAcsaAgreement.files[props.$index].id,
                      countryAcsaAgreement.files[props.$index].file.name
                    )
                  "
                >
                  <i class="tim-icons icon-minimal-down"></i> Download
                </button>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="modals.classic = false"
          >
            Close
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";
import { Table, TableColumn } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import axios from "@/axios";
import Utility from "@/mixins/utility/utility";
import Util from "@/util/util";
import { formatDate } from '@fullcalendar/core';

export default {
  name: "AgreementInformationAcsaModal",
  mixins: [Utility],
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    Id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      modals: {
        classic: false,
      },
      tableColumns: [
        {
          prop: "file.name",
          label: "File Name",
          minWidth: 200,
          scope: "col"
        },
        {
          prop: "file.sizeInKilobytes",
          label: "File Size",
          minWidth: 250,
          scope: "col"
        },
      ],
      downloading: false
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      countryAcsaAgreement: "acsaAgreement/countryAcsaAgreement",
    }),
  },
  methods: {
    ...mapActions({
      getCountryAcsaAgreement: "acsaAgreement/getCountryAcsaAgreement",
    }),
   async viewAcsa() {
      let ctx = this;
      ctx.$loaderApp.addRequest();
     await ctx.getCountryAcsaAgreement(ctx.Id).then(() => {
        ctx.modals.classic = true;
      ctx.$loaderApp.completeRequest();
      });
      ctx.$loaderApp.completeRequest();
    },
    generateReport(id, title) {
      this.downloading = true;
      let ctx = this;
      ctx.$loaderApp.addRequest();
      axios({
        url: `/api/acsaagreementfiles/${id}`,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        Util.fileDownload(response.data, title);
        ctx.downloading = false;
          ctx.$loaderApp.completeRequest();
      }).catch(err => { this.downloading = false; ctx.$loaderApp.completeRequest();});
    },
  },
};
</script>

<style>
@import "../../../../../styles/custom_buttons.css";
@import "../../../../../styles/custom_grid.css";

.label_warning {
  background-color: #f0ad4e;
  padding-top: 3px;
  padding-right: 6px;
  padding-bottom: 2px;
  padding-left: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #ffffff;
  border-radius: 0.25em;
  white-space: nowrap;
}
</style>

<style scoped>
.move-right {
  margin-left: 14em;
}
.move-right-label {
  margin-left: 14em;
}
</style>
